import React from 'react';
import Nav from '../components/Nav';
import Footer from '../components/Footer';

import Kongs1  from '../assets/Kongs1.jpg';
import Kongs2  from '../assets/Kongs2.webp';
import Kongs3  from '../assets/Kongs3.avif';
import Kongs4  from '../assets/Kongs4.jpeg';

import Kongs6  from '../assets/Kongs6.jpeg';
import Kongs7  from '../assets/Kongs7.png';



function Kongsberg() {
    const stats = [
        {
            data: "2",
            title: "Teams I was apart of (Shell and Chevron"
        },
        {
            data: "15",
            title: "Dashboards and Tables Improved"
        },
        {
            data: "5",
            title: "Developers on Team"
        },

    ]
  return (

    <main>
    <title> Kongsberg Page | Austin web designer specializing in Figma, Adobe XD, and custom coding. Crafting pixel-perfect, responsive websites.</title>
  <meta
      name="description"
      content="Top-rated website design company in Austin. Serving small businesses with affordable and effective web solutions."
  />
  <meta
      name="keywords"
      content="Austin website design, Austin web design company, Austin website development, Austin web developer, Website design Austin TX, Web design services Austin, Website development Austin, Austin website design agency
Small business website design Austin, Ecommerce website design Austin, WordPress website design Austin, Shopify website design Austin, Wix website design Austin, Custom website design Austin, WordPress developer Austin
Shopify expert Austin, Wix designer Austin, Figma web design Austin, Adobe XD design Austin, Illustrator web design Austin
Website wireframing Austin, Responsive web design Austin, Mobile-friendly, website design Austin, Website redesign Austin, Website maintenance Austin, SEO friendly website design Austin , Website accessibility Austin, Website designer near me Austin, Web design companies in Austin, Best, website designers Austin, Top web developers Austin, Austin web design services, North Austin website design, Ecommerce Shopify website design Austin, WordPress website development for small business Austin, Figma and Adobe XD website design Austin, Custom coded website design Austin TX"
  /> 


<div class="overflow-visible">
    <Nav/>
  <div class="">



<section class="block">
  <div class="bg-[#D71739] text-white">
    <div class="py-16 md:py-24 lg:py-32 px-5 md:px-10">
      <div class="max-w-[800px] mb-6 md:mb-10 lg:mb-12 mx-auto w-full max-w-7xl">
        <h1 class="font-bold text-4xl md:text-6xl">Kongsberg Digital</h1>
        <p className='text-center py-5'>UX/UI Developer (Freelance)</p>


      </div>

    </div>
  </div>
  <div class=" bg-[#E0DFDD]">
    <div class="py-12 md:py-16 lg:py-20 px-5 md:px-10">
      <div class="relative grid w-full items-start justify-start max-[991px]:flex-col max-[991px]:flex grid-cols-[480px] lg:grid-cols-[0.5fr_0.75fr_480px] gap-4 mx-auto max-w-7xl">
        <a href="#" class="inline-block max-w-full text-black">
        <img src={Kongs6} alt="Features Image" class="mx-auto inline-block h-full w-full max-w-[640px] rounded-2xl object-cover" />
        </a>
        <div class="w-full max-w-xs max-[991px]:max-w-[560px]">
          <h3 class="font-bold text-2xl md:text-3xl">Kongsberg Digital Twin (UX/UI Development)</h3>
          <div class="mb-6 mt-6 w-16 [border-top:1px_solid_rgb(0,_0,_0)]">
          </div>
          <p class="text-[#636262] text-sm sm:text-lg"> In 2020, Kongsberg group announced it's increase investment in maritime digital solutions by combining Kongsberg Digital’s two maritime divisions into one brand: Digital Ocean. I was hired as a UX/UI developer to facilitate this project and aide the Houston branch in increasing the overall look/feel of the client facing application.

</p>
        </div>
        <img src={Kongs4}alt="" class="absolute right-0 bottom-0 inline-block object-cover max-[991px]:relative max-[991px]:mt-12 max-[991px]:max-w-[480px] h-auto lg:h-[480px] w-full lg:w-[480px]"/>
      </div>
    </div>
  </div>
</section>



    <div class=" bg-[#E0DFDD]">
      <div class="px-5 md:px-10">
        <div class="mx-auto w-full max-w-7xl">
          <div class="py-16 md:py-24 lg:py-32">
            <div class="grid grid-cols-1 items-center gap-8 max-[991px]:justify-items-start sm:gap-20 lg:grid-cols-2">
              <div class="flex flex-col items-center justify-center rounded-xl bg-[#f7f6f2] p-6 max-[991px]:[grid-area:2/1/3/2]">
                <img src={Kongs2} alt="Features" class="mx-auto inline-block h-full w-full max-w-[640px] rounded-2xl object-cover" />
              </div>
              <div class="max-[991px]:max-w-[720px] ">
                <h2 class="mb-4 mt-6 pb-4 text-3xl font-extrabold md:text-5xl">Environment and Dashboards</h2>
                <div class="mb-6 max-w-[528px] md:mb-10 lg:mb-12">
                  <p class="text-xl text-[#636262]">Kongsberg Digital has delivered highly realistic maritime simulation technology for decades and our experience from the energy sector has shown us how valuable simulation technology is in bringing about functional dynamic digital twins,</p>
                  <ul class="list-disc pl-10 mt-5 mb-6 max-w-[528px] md:mb-10 lg:mb-22  text-[#636262] ">
                    <li>Cloud-Architecture, Complete with Industry-Grade APIs</li>
                    <li>What-if Scenario Analysis</li>
                    <li>Hybrid Analytics and Machine Learning Leveraging Synthetic Data </li>
                </ul>


                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <section class="block bg-[#E0DFDD] ">
  <div class="py-6 md:py-14 lg:py-12 mx-auto w-full max-w-7xl px-5 md:px-10">
    <div class="mx-auto flex-col flex max-w-3xl items-center text-center mb-8 md:mb-12 lg:mb-16">
      <div class="text-center">
        <h2 class="font-bold text-3xl md:text-5xl">Why Organizations Rally Around Digital Twin</h2>
      </div>
    </div>
    <div class="relative flex-col flex items-center justify-center bg-contain bg-center bg-no-repeat pt-10 " styles="background-image: url('https://assets.website-files.com/6458c625291a94a195e6cf3a/648825fca218588cb636c341_Group%2048114.png');">
      <div class="relative flex w-full justify-around gap-4">
        <a class="relative flex-1 flex flex-col max-w-full items-start gap-2 border border-solid border-[#d9d9d9] bg-[#2C3084] text-white p-6 text-left align-top max-[479px]:block rounded-md" href="#w-tabs-2-data-w-pane-0">
          <h5 class="text-xl font-bold">Support easier and more engaging work for staff in the field and in the office</h5>
          <div class="text-sm sm:text-sm"> </div>
        </a>
        <a class="relative flex-col flex-1 flex max-w-full items-start gap-2 border border-solid border-[#d9d9d9] bg-[#2C3084] text-white  p-6 text-left align-top max-[479px]:block rounded-md" tabindex="-1" href="#w-tabs-2-data-w-pane-1">
          <h5 class="text-xl font-bold">Link directly to asset performance objectives</h5>
          <div class="text-sm sm:text-sm"></div>
        </a>
        <a class="relative flex-col flex-1 flex max-w-full items-start gap-2 border border-solid border-[#d9d9d9] bg-[#2C3084] text-white p-6 text-left align-top max-[479px]:block rounded-md" tabindex="-1" href="#w-tabs-2-data-w-pane-2">
          <h5 class="text-xl font-bold">Enable the future of work</h5>
          <div class="text-sm sm:text-sm"></div>
        </a>
      </div>
      <section className="py-14">
            <div className="max-w-screen-xl mx-auto px-4 md:px-8">
                <ul className="flex flex-col items-center justify-center gap-x-12 gap-y-10 sm:flex-row sm:flex-wrap md:gap-x-24">
                    {
                        stats.map((item, idx) => (
                            <li key={idx} className="text-center">
                                <h4 className="text-4xl text-gray-800 font-semibold">{item.data}</h4>
                                <p className="mt-3 text-gray-600 font-medium">{item.title}</p>
                            </li>
                        ))
                    }
                </ul>
            </div>
        </section>
    </div>
  </div>
</section>
    <div class="bg-[#f7f6f2]">
      <div class="px-5 md:px-10">
        <div class="mx-auto w-full max-w-7xl">
          <div class="py-16 md:py-24 lg:py-32">
            <div class="grid grid-cols-1 items-center gap-8 max-[991px]:justify-items-start sm:gap-20 lg:grid-cols-2">
              <div class="max-[991px]:max-w-[720px]">
                <h3 class="mb-4 mt-6 text-2xl font-bold md:text-3xl">User Flow for Performance Dashboards</h3>
                <div class="mb-6 max-w-[528px] md:mb-10 lg:mb-12">
                  <p class="text-xl text-[#636262]">I was responsible for creating a user flows when a new component request was made. </p>
                  <ul class="list-disc pl-10 mt-5 mb-6 max-w-[528px] md:mb-10 lg:mb-22  text-[#636262] ">
                    <li>Reinvent Digital Customer Experience</li>
                    <li>Who will the user of this new feature/dashboard be used by?</li>
                    <li>Team dynamics evolve: Accommodate new members or leadership changes. </li>
                    <li>User needs expand: Stay responsive to shifting user preferences and requirements. </li>

                </ul>
                </div>

              </div>
              <div class="">
                <img src={Kongs1} alt="Features Image" class="mx-auto inline-block h-full w-full max-w-[640px] rounded-2xl object-cover" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>




    <div class="relative">
      <img src="https://assets.website-files.com/646f65e37fe0275cfb808405/646f66cdeeb4ddfdae25a26e_Background%20Hero.svg" alt="" class="absolute inset-[0%] -z-[1] inline-block h-full w-full max-w-full object-cover" />
      <div class="px-5 md:px-10">
        <div class="mx-auto w-full max-w-7xl">
          <div class="py-16 md:py-24 lg:py-32">
            <div class="grid grid-cols-1 items-center gap-8 max-[991px]:justify-items-start sm:gap-20 lg:grid-cols-2">
              <div class="max-[991px]:max-w-[720px]">
                <h2 class="mb-4 mt-6 pb-4 text-4xl font-bold text-white md:text-6xl">Angular Based Application</h2>
                <div class="mb-6 max-w-[480px] md:mb-10 lg:mb-12">
                <p class="list-disc mt-5 mb-6 max-w-[528px]  text-white ">
                    3D representation for Digital Twin using Angular, Three.js, WebGL</p>

                </div>
              </div>
              <div class="">
                <img src={Kongs3} alt="CTA Card Image" class="mx-auto inline-block h-full w-full max-w-[640px] rounded-2xl object-cover" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="">
      <div class="px-5 md:px-10">
        <div class="mx-auto w-full max-w-7xl">
          <div class="py-16 md:py-24 lg:py-32">
            <div class="grid grid-cols-1 items-center gap-8 max-[991px]:justify-items-start sm:gap-20 lg:grid-cols-2">
              <div class="max-[991px]:max-w-[720px]">
                <h2 class="mb-4 mt-6 pb-4 text-3xl font-extrabold md:text-5xl">Digital Twin Platform<span class="bg-contain bg-[50%_100%] bg-no-repeat" styles="background-image: url('https://assets.website-files.com/646f65e37fe0275cfb808405/6475d891098dee07b3371c01_634378b098f0f6cc605dc2bb_Vector%204.svg');"></span></h2>
                <div class="mb-6 max-w-[480px] md:mb-10 lg:mb-6">
                  <p class="text-white">The Digital Twin Platform is an web application that allows it's users to navigate the interior of designated buildings that go through the process of digital representation.

The process consists of creating a digital twin of the real-life interior of the designated building and is offered as a custom solution for each client.</p>
                </div>

              </div>
              <div class="">
                <img src={Kongs7} alt="" class="mx-auto inline-block h-full w-full max-w-[640px] object-cover" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
   <Footer/>
  </div>
</div>
</main>
  )
}

export default Kongsberg